<template>
    <b-card no-body>
      <template v-slot:header>
        <b-row>
          <b-col>
            <b-form-select :options="[{value: null, text: 'Status'}, 'pending', 'complete', 'error', 'deleted']" v-model="filter_status" class="mr-2" size='sm' style='max-width: 120px' @change="search" />
            <LoadingButton class="px-1" @click="search" :only_loading="true" :loading="loading" variant='none' size='sm' key="1"><i class="far fa-sync-alt" key="2"></i></LoadingButton>
            <b-button v-if="profile.role === 'admin'" class="px-1" @click="editing = !editing" key='b' variant='none' size='sm'><i class="far fa-edit"></i></b-button>
          </b-col>
          <b-col>
            <div>
            <!-- <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}" :disabled="profile.team.plan === null || project.status === 'pending' || profile.avatar.status != constants.voice_status.complete">Create</b-button> -->
            <b-button size="sm" variant="primary" class="float-right" :to="{name: `${collection}_batch_create`}"  :disabled="profile.team.plan === null || image_template.status === 'pending'">Create</b-button>
            <!-- <LoadingButton :loading="exporting" size="sm" variant="secondary" class="float-right mr-2" @click="export_items">Export</LoadingButton> -->
          </div>
          </b-col>
        </b-row>
      </template>

      <b-table ref="table" show-empty :items="items" @row-clicked="view_row" hover class="clickable" :fields="table_fields" selectable select-mode='range' selected-variant='secondary'>
        <template v-slot:cell(updated)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(status)='data'>
          <b-badge :class='`status-${data.value}`'>{{data.value}}</b-badge>
        </template>
      </b-table>

      <template v-slot:footer>
        <b-form inline>
          <b-button-toolbar>
            <b-button-group size="sm">
              <LoadingButton size="sm" @click="search('previous_page')" :disabled="current_page == 0" :loading="previous_page_loading">&lsaquo; Last</LoadingButton>
            </b-button-group>
            <b-button-group class="ml-2" size="sm">
              <LoadingButton size="sm" @click="search('next_page')" :disabled="items.length != page_size || no_more_results" :loading="next_page_loading">Next &rsaquo;</LoadingButton>
            </b-button-group>
          </b-button-toolbar>

          <b-form-select :options="page_size_options" v-model="page_size" @change="search" size="sm" class='ml-2'></b-form-select>
        </b-form>

      </template>
    </b-card>
</template>

<script>

import { db, FieldValue } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  name: 'image_list',
  metaInfo: {title: 'Items'},
  mixins: [ItemMixin],
  props: ['image_template', 'profile'],
  data() {
    let table_fields = ['name', 'status', 'updated', 'created']

    return {
      collection: 'image',
      filter_status: this.$route.query.status || null,
      exporting: false,
      table_fields: table_fields,
      editing: false,
      selected: [],
      retry_loading: false,
      qc_pass_loading: false,
    }
  },
  methods: {
    async search(action) {
      this.loading = true
      let query = db.collection('image_template').doc(this.$route.params.id).collection(this.collection)

      let query_params = {}
      if (this.filter_status) {
        query = query.where('status', '==', this.filter_status)
        query_params.status = this.filter_status
      } else {
        query = query.where('status', 'in', ['pending', 'processing', 'complete', 'error'])
      }

      query = query.orderBy('created', 'desc')

      if (JSON.stringify(this.$route.query) != JSON.stringify(query_params)) {
        this.$router.replace({query: query_params})
      }

      if (action == 'next_page') {
        this.next_page_loading = true
        let last_item = this.items[this.items.length-1]
        query = query.startAfter(last_item.doc).limit(this.page_size)
        this.current_page++
      } else if (action == 'previous_page') {
        this.previous_page_loading = true
        let first_item = this.items[0]
        query = query.endBefore(first_item.doc).limitToLast(this.page_size)
        this.current_page--
      } else if (action === 'export') {
        // pass
      } else {
        query = query.limit(this.page_size)
        this.current_page = 0
      }

      let docs = await query.get()

      if (action === 'export') {
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()
          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.loading = false

        return items
      }

      if (docs.docs.length > 0 || action != 'next_page') {
        this.no_more_results = false
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()
          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.items = items
      } else {
        this.no_more_results = true
        this.current_page--
      }

      if (this.items.length > 0) {
        if (action != 'previous_page') {
          // Peak ahead
          let docs = await query.startAfter(this.items[this.items.length-1].doc).limit(1).get()
          if (docs.docs.length === 0) {
            this.no_more_results = true
          } else {
            this.no_more_results = false
          }
        }
      }

      this.next_page_loading = false
      this.previous_page_loading = false
      this.loading = false
      this.$forceUpdate()
    },
    view_row(item) {
      if (this.editing === false) {
        this.$router.push({name: this.collection, params: {image: item.id, from_item: item}})
      }
    },
    async export_items() { // TODO
      this.exporting = true
      let csv = "data:text/csv;charset=utf-8,";
      csv += `name,website,video_url,video_player_url,thumbnail_url\r\n`

      let items = await this.search('export')

      for (let item of items) {
        csv += `${item.name},${item.website},${item.video_url},${item.video_player_url},${item.thumbnail_url || this.image_template.thumbnail_url}\r\n`
      }

      var link = document.createElement("a")
      link.setAttribute("href", encodeURI(csv))
      link.setAttribute("download", "items.csv")
      document.body.appendChild(link)

      link.click()
      this.exporting = false
    }
  },
  created() {
    this.search()
  },
  activated () {
    this.search()
  },
  // watch: { // TODO
  //   project: {
  //     deep: true,
  //     handler: function(project, old_project) {
  //       if (project.pending_count !== old_project.pending_count) {
  //         if (project.pending_count % 3 === 0 || (!old_project.pending_count && project.pending_count === 1)) {
  //           this.search()
  //         }
  //       }
  //     }
  //   }
  // }
}
</script>

<style scoped>

</style>
